import React, { Fragment } from 'react';

type HeaderProps = {
    column: number,
    auxFields: any
}

function ConsentAuxFieldsRow(props: HeaderProps) {    
    let { column, auxFields } = props;

    return (
        <>
            { auxFields &&
                <>
                    { Object.keys(auxFields).filter((e, i) => i % 4 === column).length ?
                        Object.keys(auxFields).filter((e, i) => i % 4 === column).map((auxField: any, index: number) => (
                            <Fragment key={index}>
                                <label className="content-capitalize">{auxField}</label>
                                <p>{auxFields[auxField]}</p>
                            </Fragment>
                        ))
                    :
                        <>
                            <label>&nbsp;</label>
                            <p>&nbsp;</p>
                        </>
                    }
                </>
            }
        </>
    );
}

export default ConsentAuxFieldsRow
